import {HTTP_STATUS_OK} from '../../smartpak/httpstatus';
import authentication from '../customeraccount/authentication';
import fetchWalletAccountData from '../shared/fetchwalletaccountdata';
import applePayHelper from './applepayhelper';
import WorldPayActions from './worldpayactions';

export const APPLE_PAY_API_VERSION = 3;

export const saveWalletItemCustomerStatus = {
    NEW: 0,
    EXISTING: 1
};

export const redirectURL = '/checkout/orderreview?cameFromApplePay=True&cameFromRegistration=True';

export default function initApplePay(total, { onWalletItemSaved, onSuccess } = {}) {
    const applePayButton = document.getElementById('apple-pay-button');

    if (applePayButton && supportsApplePay()) {
        const beginApplePaySession = createApplePaySession({
            ApplePaySession: window.ApplePaySession,
            asyncMerchantValidation: applePayHelper.performMerchantValidation,
            asyncWorldPayActions: WorldPayActions,
            saveWalletItem: fetchWalletAccountData.saveApplePayWalletItem,
            onSuccess,
            onWalletItemSaved
        });

        applePayButton.addEventListener('click', function () {
            beginApplePaySession(total);
        });
    }
}

export function createApplePaySession({
    ApplePaySession,
    asyncMerchantValidation,
    asyncWorldPayActions,
    saveWalletItem,
    onSuccess,
    onWalletItemSaved
}) {
    return total => {
        const applePaySession = new ApplePaySession(APPLE_PAY_API_VERSION, {
            countryCode: 'US',
            currencyCode: 'USD',
            supportedNetworks: ['visa', 'masterCard', 'amex', 'discover'],
            merchantCapabilities: ['supports3DS'],
            requiredShippingContactFields: ['name', 'postalAddress', 'email', 'phone'],
            requiredBillingContactFields: ['postalAddress', 'email', 'phone'],
            total
        });

        applePaySession.onvalidatemerchant = async event => {
            const merchantSession = await asyncMerchantValidation(event.validationURL);
            applePaySession.completeMerchantValidation(merchantSession);
        };

        applePaySession.onpaymentauthorized = async event => {
            try {
                const payment = event.payment;
                const walletItem = await asyncWorldPayActions(payment);
                const response = await saveWalletItem(walletItem);

                if (response.status === HTTP_STATUS_OK) {
                    applePaySession.completePayment(applePaySession.STATUS_SUCCESS);

                    if (typeof onWalletItemSaved === 'function') {
                        onWalletItemSaved();
                    }

                    if (
                        response.content.status === saveWalletItemCustomerStatus.NEW
                        && typeof onSuccess === 'function'
                    ) {
                        onSuccess();
                        return;
                    }

                    launchExistingAccountModal(payment.shippingContact.emailAddress, onSuccess);
                } else {
                    applePaySession.completePayment(applePaySession.STATUS_FAILURE);
                }
            } catch {
                applePaySession.completePayment(applePaySession.STATUS_FAILURE);
            }
        };

        applePaySession.begin();

        return applePaySession;
    };
}

export function supportsApplePay() {
    return applePayHelper.canMakeApplePayments() && applePayHelper.displayApplePay;
}

export function launchExistingAccountModal(emailAddress, onSuccess) {
    let container = document.createElement('div');

    container.append(`We found an account associated with your email, ${emailAddress}`);

    smartPak.ui.modal(container, {
        title: 'Please sign in to check out',
        buttons: {
            'Sign In': function (modal) {
                modal.close();
                authentication._launchModal({
                    success: () => {
                        if (typeof onSuccess === 'function') {
                            onSuccess();
                        }
                    }
                });
            }
        }
    });
}
